import { render } from "./column2.vue?vue&type=template&id=6c84896e"
import script from "./column2.vue?vue&type=script&lang=js"
export * from "./column2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__